/* ==========================================================================
   161.sharp — globales JS
   HTML-first, progressive enhancement. Kein Framework, kein Scroll-Polling.
   Module: Reveal, Header-Scroll-State, Quick-Add, PDP-Variant-Picker,
           Sticky-Mobile-ATC, Cart (Section Rendering), Dialoge.
   ========================================================================== */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Geld-Formatierung (EUR, de) ---------- */
  function money(cents) {
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  }

  /* ---------- Reveal via IntersectionObserver ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.s-reveal');
    if (!els.length) return;
    if (REDUCED || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Header: kompakter Scroll-State (Sentinel statt Scroll-Event) ---------- */
  function initHeader() {
    var header = document.querySelector('[data-sharp-header]');
    if (!header || !('IntersectionObserver' in window)) return;
    var sentinel = document.createElement('div');
    sentinel.style.cssText = 'position:absolute;top:0;height:1px;width:1px;';
    document.body.prepend(sentinel);
    new IntersectionObserver(function (entries) {
      header.classList.toggle('is-scrolled', !entries[0].isIntersecting);
    }).observe(sentinel);
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(html) {
    var el = document.querySelector('.s-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 's-toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.innerHTML = html;
    requestAnimationFrame(function () { el.classList.add('is-active'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-active'); }, 4000);
  }

  /* ---------- Cart-Helpers ---------- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
  }

  function addToCart(variantId, qty) {
    return fetch(window.Shopify && window.Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'Fehler'); });
      return fetch('/cart.js').then(function (res) { return res.json(); });
    }).then(function (cart) {
      updateCartCount(cart.item_count);
      return cart;
    });
  }

  /* ---------- Quick-Add (Produktkarten) ---------- */
  function initQuickAdd() {
    document.addEventListener('click', function (ev) {
      var addBtn = ev.target.closest('[data-quick-add-variant]');
      if (addBtn) {
        ev.preventDefault();
        var id = parseInt(addBtn.getAttribute('data-quick-add-variant'), 10);
        addBtn.setAttribute('aria-busy', 'true');
        addToCart(id).then(function () {
          addBtn.removeAttribute('aria-busy');
          var details = addBtn.closest('details');
          if (details) details.open = false;
          toast('Im Warenkorb. <a href="/cart">Zum Warenkorb</a>');
        }).catch(function (err) {
          addBtn.removeAttribute('aria-busy');
          toast(err.message);
        });
      }
    });
  }

  /* ---------- PDP: Variant-Picker ---------- */
  function initVariantPicker() {
    document.querySelectorAll('[data-product-form]').forEach(function (root) {
      var dataEl = root.querySelector('[data-product-json]');
      if (!dataEl) return;
      var product = JSON.parse(dataEl.textContent);
      var idInput = root.querySelector('input[name="id"]');
      var priceEl = root.querySelector('[data-price]');
      var atcBtn = root.querySelector('[data-atc]');
      var atcLabel = atcBtn ? atcBtn.querySelector('[data-atc-label]') : null;
      var restock = root.querySelector('[data-restock-slot]');
      var stickyPrice = document.querySelector('[data-sticky-price]');
      var stickyBtn = document.querySelector('[data-sticky-atc]');

      function currentVariant() {
        var selected = [];
        root.querySelectorAll('fieldset[data-option-index]').forEach(function (fs) {
          var checked = fs.querySelector('input:checked');
          if (checked) selected[parseInt(fs.dataset.optionIndex, 10)] = checked.value;
        });
        return product.variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === selected[i]; });
        });
      }

      function render() {
        var v = currentVariant();
        if (!v) return;
        idInput.value = v.id;
        if (priceEl) {
          priceEl.innerHTML = v.compare_at_price && v.compare_at_price > v.price
            ? '<span class="s-price s-price--sale"><span class="s-price__current">' + money(v.price) + '</span><s class="s-price__compare">' + money(v.compare_at_price) + '</s></span>'
            : '<span class="s-price"><span class="s-price__current">' + money(v.price) + '</span></span>';
        }
        if (stickyPrice) stickyPrice.textContent = money(v.price);
        var available = v.available;
        [atcBtn, stickyBtn].forEach(function (btn) {
          if (!btn) return;
          btn.disabled = !available;
        });
        if (atcLabel) atcLabel.textContent = available ? atcBtn.dataset.labelAdd : atcBtn.dataset.labelSoldout;
        if (stickyBtn) stickyBtn.textContent = available ? atcBtn.dataset.labelAdd : atcBtn.dataset.labelSoldout;
        if (restock) restock.hidden = available;
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }

      root.addEventListener('change', function (ev) {
        if (ev.target.matches('fieldset[data-option-index] input')) render();
      });
      render();

      /* ATC via fetch, damit der Toast statt eines Page-Reloads kommt */
      var form = root.querySelector('form[data-type="add-to-cart-form"]');
      if (form) {
        form.addEventListener('submit', function (ev) {
          ev.preventDefault();
          var v = currentVariant();
          if (!v || !v.available) return;
          atcBtn.setAttribute('aria-busy', 'true');
          addToCart(v.id, parseInt((form.querySelector('input[name="quantity"]') || {}).value, 10) || 1)
            .then(function () {
              atcBtn.removeAttribute('aria-busy');
              toast('Im Warenkorb. <a href="/cart">Zum Warenkorb</a>');
            })
            .catch(function (err) {
              atcBtn.removeAttribute('aria-busy');
              toast(err.message);
            });
        });
      }
    });
  }

  /* ---------- PDP: Sticky-Mobile-ATC ---------- */
  function initStickyAtc() {
    var bar = document.querySelector('[data-sticky-bar]');
    var anchor = document.querySelector('[data-atc]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-active', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(anchor);
    var stickyBtn = bar.querySelector('[data-sticky-atc]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var form = document.querySelector('[data-product-form] form[data-type="add-to-cart-form"]');
        if (form) form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    }
  }

  /* ---------- PDP: Galerie (Thumb → Hauptbild) ---------- */
  function initGallery() {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;
    gallery.addEventListener('click', function (ev) {
      var thumb = ev.target.closest('[data-gallery-thumb]');
      if (!thumb) return;
      var main = gallery.querySelector('[data-gallery-main] img');
      if (!main) return;
      main.src = thumb.dataset.src;
      main.srcset = thumb.dataset.srcset || '';
      main.alt = thumb.querySelector('img') ? thumb.querySelector('img').alt : '';
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
        t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
      });
    });
  }

  /* ---------- Dialoge (Size-Guide) ---------- */
  function initDialogs() {
    document.addEventListener('click', function (ev) {
      var opener = ev.target.closest('[data-dialog-open]');
      if (opener) {
        ev.preventDefault();
        var dlg = document.getElementById(opener.getAttribute('data-dialog-open'));
        if (dlg && typeof dlg.showModal === 'function') dlg.showModal();
      }
      var closer = ev.target.closest('[data-dialog-close]');
      if (closer) closer.closest('dialog').close();
    });
    /* Klick auf Backdrop schließt */
    document.querySelectorAll('dialog.s-dialog').forEach(function (dlg) {
      dlg.addEventListener('click', function (ev) {
        if (ev.target === dlg) dlg.close();
      });
    });
  }

  /* ---------- Cart: Menge ändern / entfernen via Section Rendering ---------- */
  function initCart() {
    var cartRoot = document.querySelector('[data-cart-section]');
    if (!cartRoot) return;
    var sectionId = cartRoot.dataset.cartSection;

    function rerender(cart) {
      return fetch('/cart?section_id=' + sectionId)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-section]');
          if (fresh) cartRoot.replaceWith(fresh);
          updateCartCount(cart.item_count);
          initCart(); /* neu binden */
        });
    }

    document.querySelectorAll('[data-cart-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = parseInt(btn.dataset.line, 10);
        var qty = parseInt(btn.dataset.qty, 10);
        btn.setAttribute('aria-busy', 'true');
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: line, quantity: qty })
        }).then(function (r) { return r.json(); }).then(rerender);
      });
    });
  }

  /* ---------- Init ---------- */
  function init() {
    initReveal();
    initHeader();
    initQuickAdd();
    initVariantPicker();
    initStickyAtc();
    initGallery();
    initDialogs();
    initCart();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
